"use client";

import { Instagram, Mail, Beer } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        <li><div className="h-4 w-24 bg-muted animate-pulse" /></li>
        <li><div className="h-4 w-28 bg-muted animate-pulse" /></li>
        <li><div className="h-4 w-20 bg-muted animate-pulse" /></li>
        <li><div className="h-4 w-16 bg-muted animate-pulse" /></li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-foreground text-sm font-default inline-block relative group transition-colors duration-200 hover:text-secondary">
            <span>{item.label}</span>
            <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(.7,0,.2,1)] group-hover:w-full" />
          </Link>
        </li>)}
    </ul>;
}
const tickerItems = ["STEM EXCELLENCE", "SAT MASTERY", "CALCULUS PROOF", "AP PHYSICS", "STEM EXCELLENCE", "SAT MASTERY", "CALCULUS PROOF", "AP PHYSICS"];
const SteamLines = () => <svg width="64" height="14" viewBox="0 0 64 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="text-foreground/30">
    <path d="M0 3 Q 16 0 32 3 T 64 3" stroke="currentColor" strokeWidth="1" fill="none" />
    <path d="M0 7 Q 16 4 32 7 T 64 7" stroke="currentColor" strokeWidth="1" fill="none" />
    <path d="M0 11 Q 16 8 32 11 T 64 11" stroke="currentColor" strokeWidth="1" fill="none" />
  </svg>;
export default function ApexFooter() {
  return <section data-section-id="1056" id="apex-footer" className="dark bg-background text-foreground">
      {}
      <div className="w-full border-y border-border overflow-hidden group">
        <style>{`
          @keyframes footer-marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .footer-marquee-track {
            animation: footer-marquee 38s linear infinite;
          }
          .footer-marquee-wrap:hover .footer-marquee-track {
            animation-play-state: paused;
          }
        `}</style>
        <div className="footer-marquee-wrap py-4">
          <div className="footer-marquee-track flex whitespace-nowrap will-change-transform">
            {[...tickerItems, ...tickerItems].map((item, i) => <span data-index={i} key={i} className="font-mono text-[12px] font-medium text-foreground/60 mx-6 inline-flex items-center" style={{
            letterSpacing: "0.18em"
          }}>
                <span className="inline-block w-2 h-2 bg-secondary mr-6" />
                {item}
              </span>)}
          </div>
        </div>
      </div>

      {}
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-14 py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {}
          <div className="sm:col-span-2 lg:col-span-4">
            <div className="flex items-center gap-3">
              <Link to="/HomePage" aria-label="ApexTutor home">
                <WvcLogo className="h-8 w-auto" />
              </Link>
              <span className="inline-block w-2 h-2 bg-secondary" aria-hidden="true" />
            </div>
            <p className="mt-6 font-serif italic text-[15px] leading-relaxed text-foreground/60 max-w-xs" style={{
            fontWeight: 300
          }}>
              Architecting academic ascent through precision mentorship.
            </p>
            <div className="mt-8">
              <SteamLines />
            </div>
          </div>

          {}
          <div className="lg:col-span-3">
            <div className="font-mono text-[12px] font-medium text-foreground/60 mb-5 inline-flex items-center" style={{
            letterSpacing: "0.18em"
          }}>
              <span>№ 01 — NAVIGATE</span>
              <span className="inline-block w-1.5 h-1.5 bg-secondary ml-2" aria-hidden="true" />
            </div>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-3">
            <div className="font-mono text-[12px] font-medium text-foreground/60 mb-5 inline-flex items-center" style={{
            letterSpacing: "0.18em"
          }}>
              <span>№ 02 — CONNECT</span>
              <span className="inline-block w-1.5 h-1.5 bg-secondary ml-2" aria-hidden="true" />
            </div>
            <address className="not-italic space-y-3 text-sm font-default text-foreground/80 leading-relaxed">
              <p>123 Academic Way,<br />Innovation City, ST 90210</p>
              <p className="text-foreground/60">
                Mon–Fri: 9am – 8pm<br />
                Sat: 10am – 4pm
              </p>
              <p>
                <Link to="mailto:hello@apextutor.com" className="text-foreground inline-block relative group transition-colors duration-200 hover:text-secondary">
                  <span>hello@apextutor.com</span>
                  <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(.7,0,.2,1)] group-hover:w-full" />
                </Link>
              </p>
            </address>
          </div>

          {}
          <div className="lg:col-span-2">
            <div className="font-mono text-[12px] font-medium text-foreground/60 mb-5 inline-flex items-center" style={{
            letterSpacing: "0.18em"
          }}>
              <span>№ 03 — SOCIAL</span>
              <span className="inline-block w-1.5 h-1.5 bg-secondary ml-2" aria-hidden="true" />
            </div>
            <div className="flex items-center gap-1 -ml-2">
              <Link to="#" aria-label="Instagram" className="inline-flex items-center justify-center w-8 h-8 text-foreground transition-colors duration-200 hover:text-secondary">
                <Instagram className="w-[18px] h-[18px]" strokeWidth={1.25} />
              </Link>
              
              <Link to="mailto:hello@apextutor.com" aria-label="Email" className="inline-flex items-center justify-center w-8 h-8 text-foreground transition-colors duration-200 hover:text-secondary">
                <Mail className="w-[18px] h-[18px]" strokeWidth={1.25} />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 flex justify-center">
          <Separator className="bg-foreground/15" />
        </div>

        {}
        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-mono text-[11px] font-medium text-foreground/60 inline-flex items-center" style={{
          letterSpacing: "0.14em"
        }}>
            <span>© 2026 APEXTUTOR</span>
            <span className="inline-block w-1.5 h-1.5 bg-secondary mx-3" aria-hidden="true" />
            <span>ALL RIGHTS RESERVED</span>
          </p>
          <div className="font-mono text-[11px] font-medium inline-flex items-center" style={{
          letterSpacing: "0.14em"
        }}>
            <Link to="#" className="text-foreground/70 relative group transition-colors duration-200 hover:text-secondary">
              <span>PRIVACY</span>
              <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(.7,0,.2,1)] group-hover:w-full" />
            </Link>
            <span className="inline-block w-1.5 h-1.5 bg-secondary mx-3" aria-hidden="true" />
            <Link to="#" className="text-foreground/70 relative group transition-colors duration-200 hover:text-secondary">
              <span>TERMS</span>
              <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(.7,0,.2,1)] group-hover:w-full" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}